import { GERENCIA_GAF_ID } from '../constants/gerencias_contratos';
import { EQUIPO_FLOTA, VER_CONDICION_VENTA } from '../constants/permissions';
import {
  CONDICION_APLICA_GENERAL,
  CONDICION_APLICA_VEHICULO,
  CONDICION_PARA_VENTA,
} from '../constants/constantes';

export const MENSAJE_MOVIMIENTO_VEHICULO_GAF =
  'Solo el equipo de Flota puede mover vehículos desde otras gerencias hacia GAF.';

/**
 * Obtiene el ID de una referencia, esté poblada (objeto con _id) o no (string).
 * @param {*} ref Referencia.
 */
export function obtenerId(ref) {
  if (!ref) return null;
  return typeof ref === 'object' ? ref._id || null : ref;
}

/**
 * Obtiene la gerencia de destino de una asignación, según su tipo y el asignado seleccionado
 * (persona o contrato con su gerencia_ref, o la gerencia misma).
 * @param {string} tipo Tipo de asignación: persona, contrato o gerencia.
 * @param {*} asignado Persona, contrato o gerencia seleccionada.
 */
export function obtenerGerenciaDestino(tipo, asignado) {
  if (!asignado) return null;
  switch (String(tipo).toLowerCase()) {
    case 'persona':
    case 'contrato':
      return obtenerId(asignado.gerencia_ref);
    case 'gerencia':
      return obtenerId(asignado);
    default:
      return null;
  }
}

/**
 * Indica si se permite mover un bien hacia la gerencia de destino.
 * Solo el equipo de Flota puede mover vehículos desde otras gerencias hacia GAF.
 * @param {object} params
 * @param {boolean} params.esVehiculo Si la clase del bien es vehículo.
 * @param {*} params.gerenciaOrigen Gerencia actual del bien (ID o referencia poblada).
 * @param {*} params.gerenciaDestino Gerencia de destino (ID o referencia poblada).
 * @param {object} params.permisos Permisos del usuario en sesión.
 */
export function puedeMoverBienAGerencia({ esVehiculo, gerenciaOrigen, gerenciaDestino, permisos }) {
  if (!esVehiculo || (permisos && permisos[EQUIPO_FLOTA])) return true;
  const destinoId = obtenerId(gerenciaDestino);
  const origenId = obtenerId(gerenciaOrigen);
  return !(destinoId === GERENCIA_GAF_ID && origenId !== GERENCIA_GAF_ID);
}

/**
 * Filtra las condiciones actuales disponibles según el tipo de bien y los permisos del usuario.
 * Las condiciones sin `aplica_a` se consideran de uso general.
 * @param {Array} condiciones Listado de seleccionables de contexto condiciones_actuales.
 * @param {object} params
 * @param {boolean} params.esVehiculo Si la clase del bien es vehículo.
 * @param {object} params.permisos Permisos del usuario en sesión.
 */
export function filtrarCondicionesActuales(condiciones, { esVehiculo, permisos }) {
  if (!Array.isArray(condiciones)) return [];
  const tipo = esVehiculo ? CONDICION_APLICA_VEHICULO : CONDICION_APLICA_GENERAL;
  const puedeVerVenta = Boolean(permisos && permisos[VER_CONDICION_VENTA]);

  return condiciones.filter((condicion) => {
    if (!condicion) return false;
    if (condicion.value === CONDICION_PARA_VENTA && !puedeVerVenta) return false;
    const aplicaA = Array.isArray(condicion.aplica_a) && condicion.aplica_a.length > 0 ? condicion.aplica_a : [CONDICION_APLICA_GENERAL];
    return aplicaA.includes(tipo);
  });
}
